import { useIsMobile } from 'hooks/useIsMobile'
import { TogetherCommunity, TogetherTopic } from 'interfaces/types'

import { CommunitySectionDesktop } from './components/communityDesktop'
import { CommunitySectionMobile } from './components/communityMobile'
export type CommunitySectionProps = {
  community?: TogetherCommunity
  topics?: Array<TogetherTopic>
  title?: string
  message?: string
  openAskDoctor?: (e: boolean) => void
}

export const CommunitySection = (props: CommunitySectionProps) => {
  const isMobile = useIsMobile()

  return isMobile ? (
    <CommunitySectionMobile {...props} openAskDoctor={props.openAskDoctor} />
  ) : (
    <CommunitySectionDesktop {...props} openAskDoctor={props.openAskDoctor} />
  )
}
